/* eslint-disable */
// source: vivacity/core/countline_windowed_features.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var vivacity_core_classifying_detector_class_types_pb = require('../../vivacity/core/classifying_detector_class_types_pb.js');
goog.object.extend(proto, vivacity_core_classifying_detector_class_types_pb);
var vivacity_core_tracing_context_pb = require('../../vivacity/core/tracing_context_pb.js');
goog.object.extend(proto, vivacity_core_tracing_context_pb);
var vivacity_core_detection_quality_pb = require('../../vivacity/core/detection_quality_pb.js');
goog.object.extend(proto, vivacity_core_detection_quality_pb);
goog.exportSymbol('proto.vivacity.core.CountlineWindowedClassFeatures', null, global);
goog.exportSymbol('proto.vivacity.core.CountlineWindowedFeatures', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.CountlineWindowedClassFeatures = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.CountlineWindowedClassFeatures, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.CountlineWindowedClassFeatures.displayName = 'proto.vivacity.core.CountlineWindowedClassFeatures';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.CountlineWindowedFeatures = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.core.CountlineWindowedFeatures.repeatedFields_, null);
};
goog.inherits(proto.vivacity.core.CountlineWindowedFeatures, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.CountlineWindowedFeatures.displayName = 'proto.vivacity.core.CountlineWindowedFeatures';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.CountlineWindowedClassFeatures.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.CountlineWindowedClassFeatures} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.CountlineWindowedClassFeatures.toObject = function(includeInstance, msg) {
  var f, obj = {
    classId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    numberCrossings: jspb.Message.getFieldWithDefault(msg, 2, 0),
    meanRealWorldSpaceSpeedMetersPerSecond: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    meanImageSpaceSpeedPointsPerSecond: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.CountlineWindowedClassFeatures}
 */
proto.vivacity.core.CountlineWindowedClassFeatures.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.CountlineWindowedClassFeatures;
  return proto.vivacity.core.CountlineWindowedClassFeatures.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.CountlineWindowedClassFeatures} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.CountlineWindowedClassFeatures}
 */
proto.vivacity.core.CountlineWindowedClassFeatures.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (reader.readEnum());
      msg.setClassId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumberCrossings(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMeanRealWorldSpaceSpeedMetersPerSecond(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMeanImageSpaceSpeedPointsPerSecond(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.CountlineWindowedClassFeatures.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.CountlineWindowedClassFeatures} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.CountlineWindowedClassFeatures.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClassId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNumberCrossings();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getMeanRealWorldSpaceSpeedMetersPerSecond();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getMeanImageSpaceSpeedPointsPerSecond();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * optional ClassifyingDetectorClassTypes class_id = 1;
 * @return {!proto.vivacity.core.ClassifyingDetectorClassTypes}
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.getClassId = function() {
  return /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.vivacity.core.ClassifyingDetectorClassTypes} value
 * @return {!proto.vivacity.core.CountlineWindowedClassFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.setClassId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint32 number_crossings = 2;
 * @return {number}
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.getNumberCrossings = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.CountlineWindowedClassFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.setNumberCrossings = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional float mean_real_world_space_speed_meters_per_second = 3;
 * @return {number}
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.getMeanRealWorldSpaceSpeedMetersPerSecond = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.CountlineWindowedClassFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.setMeanRealWorldSpaceSpeedMetersPerSecond = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float mean_image_space_speed_points_per_second = 4;
 * @return {number}
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.getMeanImageSpaceSpeedPointsPerSecond = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.CountlineWindowedClassFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedClassFeatures.prototype.setMeanImageSpaceSpeedPointsPerSecond = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.core.CountlineWindowedFeatures.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.CountlineWindowedFeatures.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.CountlineWindowedFeatures} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.CountlineWindowedFeatures.toObject = function(includeInstance, msg) {
  var f, obj = {
    countlineId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    visionProgramId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    windowStartTimestampMicroseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    windowLengthMicroseconds: jspb.Message.getFieldWithDefault(msg, 4, 0),
    classFeaturesClockwiseList: jspb.Message.toObjectList(msg.getClassFeaturesClockwiseList(),
    proto.vivacity.core.CountlineWindowedClassFeatures.toObject, includeInstance),
    classFeaturesAnticlockwiseList: jspb.Message.toObjectList(msg.getClassFeaturesAnticlockwiseList(),
    proto.vivacity.core.CountlineWindowedClassFeatures.toObject, includeInstance),
    aggregatedFeaturesClockwise: (f = msg.getAggregatedFeaturesClockwise()) && proto.vivacity.core.CountlineWindowedClassFeatures.toObject(includeInstance, f),
    aggregatedFeaturesAnticlockwise: (f = msg.getAggregatedFeaturesAnticlockwise()) && proto.vivacity.core.CountlineWindowedClassFeatures.toObject(includeInstance, f),
    tracingCtx: (f = msg.getTracingCtx()) && vivacity_core_tracing_context_pb.TracingContext.toObject(includeInstance, f),
    detectionQuality: (f = msg.getDetectionQuality()) && vivacity_core_detection_quality_pb.DetectionQuality.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.CountlineWindowedFeatures}
 */
proto.vivacity.core.CountlineWindowedFeatures.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.CountlineWindowedFeatures;
  return proto.vivacity.core.CountlineWindowedFeatures.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.CountlineWindowedFeatures} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.CountlineWindowedFeatures}
 */
proto.vivacity.core.CountlineWindowedFeatures.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCountlineId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVisionProgramId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setWindowStartTimestampMicroseconds(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setWindowLengthMicroseconds(value);
      break;
    case 5:
      var value = new proto.vivacity.core.CountlineWindowedClassFeatures;
      reader.readMessage(value,proto.vivacity.core.CountlineWindowedClassFeatures.deserializeBinaryFromReader);
      msg.addClassFeaturesClockwise(value);
      break;
    case 6:
      var value = new proto.vivacity.core.CountlineWindowedClassFeatures;
      reader.readMessage(value,proto.vivacity.core.CountlineWindowedClassFeatures.deserializeBinaryFromReader);
      msg.addClassFeaturesAnticlockwise(value);
      break;
    case 7:
      var value = new proto.vivacity.core.CountlineWindowedClassFeatures;
      reader.readMessage(value,proto.vivacity.core.CountlineWindowedClassFeatures.deserializeBinaryFromReader);
      msg.setAggregatedFeaturesClockwise(value);
      break;
    case 8:
      var value = new proto.vivacity.core.CountlineWindowedClassFeatures;
      reader.readMessage(value,proto.vivacity.core.CountlineWindowedClassFeatures.deserializeBinaryFromReader);
      msg.setAggregatedFeaturesAnticlockwise(value);
      break;
    case 9:
      var value = new vivacity_core_tracing_context_pb.TracingContext;
      reader.readMessage(value,vivacity_core_tracing_context_pb.TracingContext.deserializeBinaryFromReader);
      msg.setTracingCtx(value);
      break;
    case 10:
      var value = new vivacity_core_detection_quality_pb.DetectionQuality;
      reader.readMessage(value,vivacity_core_detection_quality_pb.DetectionQuality.deserializeBinaryFromReader);
      msg.setDetectionQuality(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.CountlineWindowedFeatures.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.CountlineWindowedFeatures} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.CountlineWindowedFeatures.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountlineId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getVisionProgramId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getWindowStartTimestampMicroseconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getWindowLengthMicroseconds();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getClassFeaturesClockwiseList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.vivacity.core.CountlineWindowedClassFeatures.serializeBinaryToWriter
    );
  }
  f = message.getClassFeaturesAnticlockwiseList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.vivacity.core.CountlineWindowedClassFeatures.serializeBinaryToWriter
    );
  }
  f = message.getAggregatedFeaturesClockwise();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.vivacity.core.CountlineWindowedClassFeatures.serializeBinaryToWriter
    );
  }
  f = message.getAggregatedFeaturesAnticlockwise();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.vivacity.core.CountlineWindowedClassFeatures.serializeBinaryToWriter
    );
  }
  f = message.getTracingCtx();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      vivacity_core_tracing_context_pb.TracingContext.serializeBinaryToWriter
    );
  }
  f = message.getDetectionQuality();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      vivacity_core_detection_quality_pb.DetectionQuality.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 countline_id = 1;
 * @return {number}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getCountlineId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.setCountlineId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 vision_program_id = 2;
 * @return {number}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getVisionProgramId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.setVisionProgramId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 window_start_timestamp_microseconds = 3;
 * @return {number}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getWindowStartTimestampMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.setWindowStartTimestampMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 window_length_microseconds = 4;
 * @return {number}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getWindowLengthMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.setWindowLengthMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated CountlineWindowedClassFeatures class_features_clockwise = 5;
 * @return {!Array<!proto.vivacity.core.CountlineWindowedClassFeatures>}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getClassFeaturesClockwiseList = function() {
  return /** @type{!Array<!proto.vivacity.core.CountlineWindowedClassFeatures>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vivacity.core.CountlineWindowedClassFeatures, 5));
};


/**
 * @param {!Array<!proto.vivacity.core.CountlineWindowedClassFeatures>} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
*/
proto.vivacity.core.CountlineWindowedFeatures.prototype.setClassFeaturesClockwiseList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.vivacity.core.CountlineWindowedClassFeatures=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.CountlineWindowedClassFeatures}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.addClassFeaturesClockwise = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.vivacity.core.CountlineWindowedClassFeatures, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.clearClassFeaturesClockwiseList = function() {
  return this.setClassFeaturesClockwiseList([]);
};


/**
 * repeated CountlineWindowedClassFeatures class_features_anticlockwise = 6;
 * @return {!Array<!proto.vivacity.core.CountlineWindowedClassFeatures>}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getClassFeaturesAnticlockwiseList = function() {
  return /** @type{!Array<!proto.vivacity.core.CountlineWindowedClassFeatures>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vivacity.core.CountlineWindowedClassFeatures, 6));
};


/**
 * @param {!Array<!proto.vivacity.core.CountlineWindowedClassFeatures>} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
*/
proto.vivacity.core.CountlineWindowedFeatures.prototype.setClassFeaturesAnticlockwiseList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.vivacity.core.CountlineWindowedClassFeatures=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.CountlineWindowedClassFeatures}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.addClassFeaturesAnticlockwise = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.vivacity.core.CountlineWindowedClassFeatures, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.clearClassFeaturesAnticlockwiseList = function() {
  return this.setClassFeaturesAnticlockwiseList([]);
};


/**
 * optional CountlineWindowedClassFeatures aggregated_features_clockwise = 7;
 * @return {?proto.vivacity.core.CountlineWindowedClassFeatures}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getAggregatedFeaturesClockwise = function() {
  return /** @type{?proto.vivacity.core.CountlineWindowedClassFeatures} */ (
    jspb.Message.getWrapperField(this, proto.vivacity.core.CountlineWindowedClassFeatures, 7));
};


/**
 * @param {?proto.vivacity.core.CountlineWindowedClassFeatures|undefined} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
*/
proto.vivacity.core.CountlineWindowedFeatures.prototype.setAggregatedFeaturesClockwise = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.clearAggregatedFeaturesClockwise = function() {
  return this.setAggregatedFeaturesClockwise(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.hasAggregatedFeaturesClockwise = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional CountlineWindowedClassFeatures aggregated_features_anticlockwise = 8;
 * @return {?proto.vivacity.core.CountlineWindowedClassFeatures}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getAggregatedFeaturesAnticlockwise = function() {
  return /** @type{?proto.vivacity.core.CountlineWindowedClassFeatures} */ (
    jspb.Message.getWrapperField(this, proto.vivacity.core.CountlineWindowedClassFeatures, 8));
};


/**
 * @param {?proto.vivacity.core.CountlineWindowedClassFeatures|undefined} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
*/
proto.vivacity.core.CountlineWindowedFeatures.prototype.setAggregatedFeaturesAnticlockwise = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.clearAggregatedFeaturesAnticlockwise = function() {
  return this.setAggregatedFeaturesAnticlockwise(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.hasAggregatedFeaturesAnticlockwise = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional TracingContext tracing_ctx = 9;
 * @return {?proto.vivacity.core.TracingContext}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getTracingCtx = function() {
  return /** @type{?proto.vivacity.core.TracingContext} */ (
    jspb.Message.getWrapperField(this, vivacity_core_tracing_context_pb.TracingContext, 9));
};


/**
 * @param {?proto.vivacity.core.TracingContext|undefined} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
*/
proto.vivacity.core.CountlineWindowedFeatures.prototype.setTracingCtx = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.clearTracingCtx = function() {
  return this.setTracingCtx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.hasTracingCtx = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional DetectionQuality detection_quality = 10;
 * @return {?proto.vivacity.core.DetectionQuality}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.getDetectionQuality = function() {
  return /** @type{?proto.vivacity.core.DetectionQuality} */ (
    jspb.Message.getWrapperField(this, vivacity_core_detection_quality_pb.DetectionQuality, 10));
};


/**
 * @param {?proto.vivacity.core.DetectionQuality|undefined} value
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
*/
proto.vivacity.core.CountlineWindowedFeatures.prototype.setDetectionQuality = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.CountlineWindowedFeatures} returns this
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.clearDetectionQuality = function() {
  return this.setDetectionQuality(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.CountlineWindowedFeatures.prototype.hasDetectionQuality = function() {
  return jspb.Message.getField(this, 10) != null;
};


goog.object.extend(exports, proto.vivacity.core);
